const CryptoJS = require('crypto-js');
export function md5(pwd) {
	const keyHex = CryptoJS.enc.Utf8.parse("wtkjtayh");
	const encrypted = CryptoJS.DES.encrypt(pwd, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}




// WEBPACK FOOTER //
// ./src/utils/md5.js